import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Mail, Lock, LogIn } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/portfolio');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0E17]">
      <Header />
      <main className="flex items-center justify-center min-h-[calc(100vh-200px)] px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-[#F59E0B]/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <LogIn className="w-8 h-8 text-[#F59E0B]" />
            </div>
            <h1 className="font-heading text-3xl font-medium text-[#F8FAFC] mb-2" data-testid="login-title">Welcome Back</h1>
            <p className="text-[#94A3B8]">Sign in to your trading account</p>
          </div>

          <div className="bg-[#121826] rounded-2xl border border-[#1E293B] p-8">
            {error && (
              <div className="bg-[#EF4444]/10 border border-[#EF4444]/30 text-[#EF4444] px-4 py-3 rounded-lg mb-6 text-sm" data-testid="login-error">{error}</div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
              <div>
                <label className="text-[#94A3B8] text-sm font-medium mb-2 block">Email</label>
                <div className="relative">
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                    className="bg-[#0A0E17] border-[#1E293B] text-[#F8FAFC] pl-10 focus:ring-[#F59E0B] focus:border-[#F59E0B]"
                    placeholder="trader@bollywood.com" data-testid="login-email-input" />
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
                </div>
              </div>

              <div>
                <label className="text-[#94A3B8] text-sm font-medium mb-2 block">Password</label>
                <div className="relative">
                  <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                    className="bg-[#0A0E17] border-[#1E293B] text-[#F8FAFC] pl-10 focus:ring-[#F59E0B] focus:border-[#F59E0B]"
                    placeholder="Enter your password" data-testid="login-password-input" />
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
                </div>
              </div>

              <Button type="submit" disabled={loading}
                className="w-full bg-[#F59E0B] hover:bg-[#D97706] text-black font-semibold h-12"
                data-testid="login-submit-btn"
              >{loading ? 'Signing in...' : 'Sign In'}</Button>
            </form>

            <p className="text-center text-[#64748B] text-sm mt-6">
              Don't have an account?{' '}
              <Link to="/register" className="text-[#F59E0B] hover:underline" data-testid="signup-link">Sign up free</Link>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Login;
